import { IndustryPage } from './IndustryPage'
import { industriesData } from '@/data/industries'

export default function Engineering() {
  return <IndustryPage industry={industriesData.engineering!} />
}
